export const common = {
  "app_name": "صورتي",
  "search_placeholder": "ابحث بالمدينة، التصنيف، أو اسم المصور...",
  "notifications": "الإشعارات",
  "login": "تسجيل الدخول",
  "register": "إنشاء حساب",
  "guest_browse": "تصفح كزائر",
  "start_browsing": "ابدأ التصفح الآن",
  "buy_now": "اشترِ الآن",
  "download": "تحميل",
  "view_more": "عرض المزيد",
  "my_library": "ملفاتي",
  "favorites": "المفضلة",
  "profile": "الملف الشخصي",
  "logout": "تسجيل الخروج",
  "price": "السعر",
  "photographer": "المصور",
  "city": "المدينة",
  "location": "الموقع",
  "views": "المشاهدات",
  "downloads": "التحميلات",
  "payment_success": "تمت عملية الشراء بنجاح",
  "categories": {
    "photos": "صور فوتوغرافية",
    "videos": "مقاطع فيديو",
    "nature": "مشاهد طبيعية",
    "religious": "معالم دينية",
    "cities": "مدن سعودية"
  },
  "payment_methods": {
    "mada": "مدى",
    "visa": "فيزا",
    "apple_pay": "Apple Pay"
  }
};

export default common;